<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <DataGetter
      @dataAvailable="
        data => {
          documents = data
          this.isLoading = false
        }
      "
      v-if="isLoading"
      contentId="kycDocuments"
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 bg-[#f4f4f5] pt-8 z-[2]"
    >
      <div class="text-4xl font-bold title-color">Documents</div>
    </div>
    <div class="sticky top-16 bg-[#f4f4f5] py-3 pt-6">
      <div class="flex justify-between items-center">
        <div
          class="w-full md:w-auto grid grid-cols-3 md:flex gap-4 p-1 bg-white rounded-2xl"
        >
          <button
            class="relative px-4 py-2 rounded-xl flex items-center justify-center"
            v-for="(status, i) in statuses"
            :key="i"
            @click="activeStatus = status.id"
          >
            <div
              :class="{
                'w-full h-full bg-primary': activeStatus == status.id,
                'w-0 h-0 bg-transparent': activeStatus !== status.id,
              }"
              class="duration-300 absolute rounded-xl"
            ></div>
            <div
              class="relative"
              :class="{
                'text-white': activeStatus == status.id,
                '': activeStatus !== status.id,
              }"
            >
              {{ status.name }}
            </div>
          </button>
        </div>
      </div>
    </div>
    <div class="py-4"></div>
    <div v-if="isLoading || documents.length > 0">
      <div class="py-4"></div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div
          v-for="(el, i) in isLoading ? shimmerOrders : filteredDocuments"
          :key="i"
          class="bg-white border rounded-3xl p-4 flex flex-col shadow-b-xl"
          :class="{ shimmerElement: el.shimmer }"
        >
          <div
            class="flex justify-between items-center border-b border-dashed pt-2 pb-4"
          >
            <div class="flex items-center gap-2 text-lg">
              <router-link
                :to="`/stores/${el.externalId}`"
                class="items-center gap-2 flex text-secondary text-sm font-medium py-2 px-4 ripple !pointer-events-auto underline"
              >
                <div>{{ el.data?.storeName }}</div>
                <div class="w-5 h-5">Voir</div>
              </router-link>
            </div>
            <div
              class="flex items-center gap-3 cursor-pointer"
              @click="startStatusUpdate(el)"
            >
              <div
                class="py-1 px-3 rounded-lg flex items-center gap-2 relative"
                :style="{
                  backgroundColor: statuses[el.validationStatus]?.background,
                  color: statuses[el.validationStatus]?.color,
                }"
              >
                <div>
                  {{
                    statuses[el.validationStatus]?.name || el.validationStatus
                  }}
                </div>
                <div class="w-5 h-5">
                  <img
                    class="w-full h-full"
                    src="@/assets/images/all/pen.svg"
                    alt=""
                  />
                </div>
              </div>
              <!-- <div class="w-8 h-8">
                <img
                  class="w-full h-full"
                  src="@/assets/images/all/edit.svg"
                  alt=""
                />
              </div> -->
            </div>
          </div>
          <div class="py-2"></div>

          <div class="flex flex-col gap-1">
            <div class="font-bold">Prorpiétaire:</div>
            <div class="flex">
              <div
                class="w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
              >
                Prénom
              </div>
              <div class="font-bold title-color">
                {{ el.data?.firstName }}
              </div>
            </div>

            <div class="flex">
              <div
                class="w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
              >
                Nom
              </div>
              <div class="font-bold title-color">
                {{ el.data?.lastName == 'none' ? '-' : el.data?.lastName }}
              </div>
            </div>

            <div class="flex">
              <div
                class="w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
              >
                Email
              </div>
              <div class="font-bold title-color">
                {{ el.data?.userEmail }}
              </div>
            </div>

            <div class="py-1"></div>
            <div class="font-bold">Entreprise:</div>
            <div class="flex">
              <div
                class="w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
              >
                Nom de l'entreprise
              </div>
              <div class="font-bold title-color">
                {{ el.data?.companyName }}
              </div>
            </div>

            <div class="flex">
              <div
                class="w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
              >
                Numéro de téléphone
              </div>
              <div class="font-bold title-color">
                {{ el.data?.phoneNumber }}
              </div>
            </div>

            <div class="flex">
              <div
                class="w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
              >
                Licence commercial
              </div>
              <div class="font-bold title-color">
                {{ el.data?.commercialLicenceId }}
              </div>
            </div>

            <div class="flex">
              <div
                class="w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
              >
                Site web
              </div>
              <div class="font-bold title-color">
                {{ el.data?.website || 'non renseillé' }}
              </div>
            </div>

            <div class="py-1"></div>
            <div class="font-bold">Localisation:</div>
            <div class="flex">
              <div
                class="w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
              >
                Pays
              </div>
              <div class="font-bold title-color">
                {{ $Countries.find(el.data?.countryCode)?.countryName }}
              </div>
            </div>

            <div class="flex">
              <div
                class="w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
              >
                Etat / province
              </div>
              <div class="font-bold title-color">
                {{ el.data?.state }}
              </div>
            </div>

            <div class="flex">
              <div
                class="w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
              >
                Ville
              </div>
              <div class="font-bold title-color">
                {{ el.data?.city }}
              </div>
            </div>

            <div class="flex">
              <div
                class="w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
              >
                Code postale
              </div>
              <div class="font-bold title-color">
                {{ el.data?.postalCode }}
              </div>
            </div>

            <div class="flex">
              <div
                class="w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
              >
                Adresse
              </div>
              <div class="font-bold title-color">
                {{ el.data?.addresss }}
              </div>
            </div>
          </div>

          <div class="py-2 mt-auto"></div>
          <div class="flex gap-12">
            <div>
              <div class="text-sm">Date</div>
              <div class="pt-1"></div>
              <div class="text-sm md:text-base font-bold title-color">
                {{
                  $Commons.timestampToDate(
                    el.submitionDate,
                    'DD MMM YYYY, hh:mm',
                  )
                }}
              </div>
            </div>
            <div>
              <div class="text-sm">Nom de la boutique</div>
              <div class="pt-1"></div>
              <div class="text-sm md:text-base font-bold title-color">
                {{ el.data?.storeName }}
              </div>
            </div>
            <div>
              <div class="text-sm">
                Documents ({{ el.data?.pictures?.length }})
              </div>
              <div class="pt-1"></div>
              <div
                class="text-sm md:text-base font-bold title-color flex gap-2 items-center cursor-pointer"
                @click="exportDocumentFiles(el)"
              >
                <div>Télécharger</div>
                <div class="w-5 h-5 rotate-180">
                  <img
                    src="@/assets/images/all/arrow-up-black.svg"
                    class="w-full h-full"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="h-[60vh] w-full flex-col items-center justify-center flex"
      v-else
    >
      <div class="w-1/5">
        <img src="@/assets/images/empty/folder.png" alt="" />
      </div>
      <div class="py-1"></div>
      <div class="text-center">
        <div class="py-1"></div>
        <div class="text-4xl title-color font-bold">
          Aucun document disponible
        </div>
        <div class="py-1"></div>
        <div class="text-lg">
          Les documents des boutiques s'afficheront ici. <br />
        </div>
        <div class="py-3"></div>
      </div>
    </div>
    <EventListener
      :events="['kyc_status_updated', 'failed_to_update_kyc_status']"
      @kyc_status_updated="onStatusUpdated"
      @failed_to_update_kyc_status="onStatusNotUpdated"
    />
  </div>
</template>

<script>
import DataGetter from '@/components/utils/DataGetter.vue'
import DotLottieComponent from '@/components/utils/DotLottieComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'
import { exportFiles } from '@/utils/plugins/exportFiles'

export default {
  name: 'homeComponent',
  components: { DataGetter, DotLottieComponent, EventListener },
  data() {
    return {
      eventsIds: [],
      documents: [],
      activeTab: 'home',
      isLoading: true,
      shimmerOrders: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
      statuses: {
        all: { id: 'all', name: 'Tout' },
        validated: {
          id: 'validated',
          name: 'Validé',
          background: '#EAEEFF',
          color: '#2930B5',
        },
        filled: {
          id: 'filled',
          name: 'En attente de validation',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        rejected: {
          id: 'rejected',
          name: 'Rejeté',
          background: '#EEF2F3',
          color: '#696969',
        },
      },
      paymentMethods: {
        card: 'Carte bancaire',
        mobileMoney: 'Mobile Money',
      },
      activeStatus: 'all',
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {},
  methods: {
    setActiveStatus(statusId) {
      this.activeStatus = statusId
    },
    async exportDocumentFiles(document) {
      this.$Events.dispatchEvent('start_loading', {
        title: 'Téléchargement des fichiers',
      })
      const files = document.data.pictures.map(pic => ({ url: pic }))
      const exportName = `documents_${document.data.companyName}_${document.data.storeName}`
      await exportFiles(files, exportName)
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Fichier exporté',
        body: "Les documents de l'entreprise ont été téléchargé avec succès",
      })
    },
    async startStatusUpdate(document) {
      const options = [
        {
          id: 'validated',
          name: 'Valider document',
        },
        {
          id: 'rejected',
          name: 'Rejeter document',
        },
        { id: 'notFilled', name: 'Supprimer le dossier' },
      ]
      const prompt = await window.choicePrompt({
        title: "Validez ou rejeter les documents de l'entreprise",
        // subtitle:
        //   'Le client p',
        options,
        formatDisplay: data => data?.name || '',
        successText: 'Enrégistrer',
      })
      if (!prompt.accepted || !prompt.data) return null
      console.log(prompt.data)
      this.$Events.dispatchEvent('start_loading')
      this.$Events.dispatchEvent('kyc_document_status_updated', {
        id: document.id,
        status: prompt.data.id,
      })
    },
    onStatusUpdated() {
      this.isLoading = true
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Validation des documents enrégistré',
        body: 'Nous avons enrégistré le nouvel état des documents.',
      })
    },
    onStatusNotUpdated() {
      this.isLoading = true
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: "Echec d'enrégistrement",
        body: "Nous n'arrivons pas à modifier l'état des documents, veuillez réessayer",
      })
    },
  },
  computed: {
    filteredDocuments() {
      if (this.activeStatus == 'all') return this.documents
      return this.documents.filter(
        order => order.validationStatus == this.activeStatus,
      )
    },
  },
  watch: {
    activeStatus() {
      this.isLoading = true
    },
  },
}
</script>
